export default {
  state: {
    multipleBookRoomList: []
  },
  getters: {},
  mutations: {
    submitMultipleBookRoomList: (state, value) => {
      console.log('多选的房间',value)
      state.multipleBookRoomList = value
    },
    clearMultipleBookRoomList: (state, value) => {
      console.log('清空多选的房间')
      state.multipleBookRoomList = []
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/multipleBook.js